module.exports = __webpack_public_path__ + "img/motor_no66.67ac025b.jpg";